export default {"src":"/_next/static/media/fire.9edcdf27.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};